import { memo } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export interface NextStepsDialogProps {
  open: boolean;
  onClose: () => void;
}

const NextStepsDialog = memo(({ open, onClose }: NextStepsDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Próximos passos com este questionário</DialogTitle>
      <DialogContent dividers>
        <DialogContentText sx={{ mb: 2 }}>
          Questionário salvo (simulação). A partir daqui, você poderá conectar
          este conteúdo com outros pontos do Fluxmed para usar nas rotinas do
          dia a dia.
        </DialogContentText>

        <Stack spacing={1.5}>
          <Typography variant="subtitle2" fontWeight={600}>
            Como você pode usar este questionário?
          </Typography>
          <Typography variant="body2">
            • Criar um template de mensagem no CRM com um{" "}
            <strong>link para este questionário</strong>, facilitando o envio
            por WhatsApp, e-mail ou link direto.
          </Typography>
          <Typography variant="body2">
            • Definir este questionário como parte do fluxo de{" "}
            <strong>pré-consulta, pós-consulta ou acompanhamento</strong>,
            alinhando com o gerenciamento em{" "}
            <strong>“Gerenciamento de Questionários”</strong>.
          </Typography>
          <Typography variant="body2">
            • Usar as respostas como insumo rápido antes de abrir o prontuário,
            enxergando insights na tela de gerenciamento.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Entendi</Button>
      </DialogActions>
    </Dialog>
  );
});

NextStepsDialog.displayName = "NextStepsDialog";

export default NextStepsDialog;
